module.exports = __webpack_public_path__ + "static/media/card.9c55ee47.svg";